<template>
    <div class="item" @click.self="isCollapsed = !isCollapsed;">
        <div class="amount">
            <div class="circle" :style="{ backgroundColor: actionColor }">{{ amount }}</div>
        </div>
        <div class="text">
            <div>
                <div @click.self="isCollapsed = !isCollapsed;">{{ title }}</div>
            </div>
            <div class="details" v-if="!isCollapsed">
                <div v-for="forecast in forecasts" :key="forecast.id" :style="{ borderColor: actionColor }">
                    <a :href="`${ROUTES.BASE}/${forecast.id}`">{{ forecast.reference }} • {{ forecast.name }}</a>
                </div>
                <div v-for="forecastWindow in forecastWindows" :key="forecastWindow.id" :style="{ borderColor: actionColor }">
                    <a :href="`${ROUTES.BASE}/window/${forecastWindow.id}`"
                        >{{ forecastWindow.forecastReference }} • {{ forecastWindow.forecastName }} • {{ forecastWindow.zoneName }}</a
                    >
                </div>
            </div>
        </div>
        <div class="arrow" @click.self="isCollapsed = !isCollapsed;">
            <template v-if="isCollapsed">
                &#x25C2;
            </template>
            <template v-else>
                &#x25BE;
            </template>
        </div>
    </div>
</template>
<script>
import { ROUTES } from "@/components/forecasts/router";

export default {
    components: {},
    props: {
        forecasts: {
            type: Array,
            required: false,
            default: () => []
        },
        forecastWindows: {
            type: Array,
            required: false,
            default: () => []
        },
        title: {
            type: String,
            required: true
        },
        amount: {
            type: Number,
            required: true
        },
        actionColor: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            ROUTES,
            isCollapsed: true
        };
    },
    computed: {},
    methods: {}
};
</script>
<style scoped lang="scss">
@import "../../../../assets/css/themes";
.item {
    width: 100%;
    border-bottom: 1px solid #a9a9a9;
    padding: 15px 0;
    display: flex;
    cursor: pointer;
    .details {
        font-weight: bold;
        padding: 10px;
        div {
            border-left: 5px solid #a9a9a9;
            padding-left: 5px;
            margin: 15px 0;
        }
    }
    .arrow {
        margin-left: auto;
        font-weight: bold;
        font-size: 1.3em;
        color: #a9a9a9;
    }
    .circle {
        border-radius: 50%;
        padding: 5px;
        color: #ffffff;
        font-weight: bold;
        width: 25px;
        height: 25px;
        text-align: center;
    }
    .amount {
        margin-right: 10px;
    }
    .text {
        font-weight: bold;
        padding-top: 3px;
    }
    a {
        text-decoration: none;
        color: $color2;
    }
}
</style>



// WEBPACK FOOTER //
// RequiredActionsItem.vue?2ad43431